var _excluded = ["olLayer", "layerDetails"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { useCallback, useEffect } from 'react';
import OlVectorSource from 'ol/source/Vector';
import { getOptions } from '../utils';
import useApplicationState from '../../hooks/useApplicationState';
import GeoJSON from 'ol/format/GeoJSON';
import { bbox as bboxStrategy } from 'ol/loadingstrategy';
import { useDeepCompareMemoize } from 'use-deep-compare-effect';
var allWFSOptions = {
  attributions: undefined,
  features: undefined,
  overlaps: true,
  useSpatialIndex: true,
  wrapX: true
};

var WFS = _ref => {
  var {
    olLayer,
    layerDetails
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var {
    apiKey
  } = useApplicationState();
  var wfsLoader = useCallback((extent, _resolution, _projection, success, failure) => {
    if (apiKey && layerDetails) {
      var url = "".concat(layerDetails.serviceUrl, "?service=WFS&") + "version=1.1.0&request=GetFeature&typename=".concat(layerDetails.ogcLayerName, "&") + "outputFormat=application/json&srsname=".concat(layerDetails.epsgName, "&") + 'bbox=' + extent.join(',') + ",".concat(layerDetails.epsgName);
      var xhr = new XMLHttpRequest();
      xhr.open('GET', url);
      xhr.setRequestHeader('X-API-Key', apiKey);

      xhr.onload = function () {
        if (xhr.status === 200) {
          var format = new GeoJSON();
          var features = format.readFeatures(xhr.responseText); // Add fetched features to wfs layer

          if (features.length) {
            var _olLayer$getSource;

            olLayer === null || olLayer === void 0 ? void 0 : (_olLayer$getSource = olLayer.getSource()) === null || _olLayer$getSource === void 0 ? void 0 : _olLayer$getSource.addFeatures(features);
          }

          success(features);
        } else {
          failure();
        }
      };

      xhr.send();
    }
  }, [apiKey, layerDetails, olLayer]); // Memoize props and options to avoid unnecessary renders

  var memoizedProps = useDeepCompareMemoize(props);
  var memoizedOptions = useDeepCompareMemoize(_objectSpread(_objectSpread({}, getOptions(Object.assign(allWFSOptions, memoizedProps))), {}, {
    loader: wfsLoader,
    strategy: bboxStrategy,
    format: new GeoJSON()
  }));
  useEffect(() => {
    var vectorSource = new OlVectorSource(memoizedOptions);
    olLayer === null || olLayer === void 0 ? void 0 : olLayer.setSource(vectorSource);
    return () => {
      var _olLayer$getSource2;

      olLayer === null || olLayer === void 0 ? void 0 : (_olLayer$getSource2 = olLayer.getSource()) === null || _olLayer$getSource2 === void 0 ? void 0 : _olLayer$getSource2.dispose();
    };
  }, [memoizedOptions, olLayer]);
  return null;
};

export default WFS;